import { TemplateType_Slug } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';

export const SETTINGS_MODAL_INTERACTION_DELAY = 400;

export const TemplateTypeTitleMap: Partial<Record<TemplateType_Slug, string>> = {
  [TemplateType_Slug.MANUAL_APPOINTMENT_REMINDER]: 'Schedule',
  [TemplateType_Slug.MANUAL_REVIEW_REQUEST]: 'Review',
  [TemplateType_Slug.MANUAL_REVIEW_REQUEST_PET]: 'Review',
  [TemplateType_Slug.MANUAL_PAYMENT_REQUEST]: 'Payments',
  [TemplateType_Slug.MANUAL_FORMS_MESSAGE]: 'Forms',
};
